export default {
  nav: {
    recommended: "Recommended",
    hours: "Hours",
    directions: "How to get there",
  },
  header: {
    whatsapp: "WhatsApp",
    switchAria: "Change language",
  },
  hero: {
    eyebrow: "Colombo-Asian Kitchen · Salento, Quindío",
    title: "Ramen and signature cuisine in Salento",
    paragraph:
      "Flavors of Asia prepared with produce from the Coffee Region, in an intimate space surrounded by forest.",
    ctaWhatsapp: "Write to us on WhatsApp",
    ctaDirections: "How to get there",
    bottomLine: "Monday to Saturday from 1:00 p.m. · Carrera 5 #7-34",
    imageAlt: "Steaming bowl of ramen at MÂJI by Cerón, restaurant in Salento, Quindío",
  },
  about: {
    title: "A kitchen that joins two territories",
    text: "MÂJI by Cerón was born in Salento in 2023, led by chef Diana Cerón and Grupo Cerón. Our menu is inspired by ramen culture and travels through the flavors of Asia with techniques and ingredients from Quindío: peppers from Popayán and Putumayo, Chiche Perro chili, scallions grown by local farmers and house-made ferments. Every dish has an origin and a story our team can tell you at the table.",
  },
  signature: {
    title: "Chef's recommendations",
    subtitle: "The signature dishes that best tell who we are.",
    note: "The full menu includes starters, vegetarian options, a children's menu, desserts, fermented drinks and signature cocktails.",
    cta: "View the menu",
  },
  dishes: {
    macao: {
      tag: "Most ordered",
      name: "Macao Ramen",
      description:
        "House broth scented with seven peppers, from Sichuan, Popayán and Putumayo. Not spicy: aromatic. With pork belly, crispy bacon, crispy shrimp and egg.",
      alt: "Macao Ramen, ramen in Salento, at MÂJI by Cerón, restaurant in Salento",
    },
    junco: {
      tag: "Spicy",
      name: "Junco Ramen",
      description:
        "Ramen with local Chiche Perro chili, miso paste, breaded chicken, ginger, egg and scallions grown by local farmers.",
      alt: "Junco Ramen, spicy ramen at MÂJI by Cerón, restaurant in Salento",
    },
    sirloin: {
      tag: "Ramen",
      name: "Sirloin Ramen",
      description:
        "Grilled sirloin, medium, over miso broth, with rolled omelette, sesame, butter and mushrooms.",
      alt: "Sirloin Ramen at MÂJI by Cerón, ramen in Salento",
    },
    fish: {
      tag: "From the sea",
      name: "Fish and Shrimp Ramen",
      description:
        "Shrimp and white fish in an octopus cream broth with citrus notes, ginger, lemongrass, annatto and coconut oil.",
      alt: "Fish and Shrimp Ramen at MÂJI by Cerón, Asian cuisine in Salento",
    },
    gyudon: {
      tag: "Favorite rice",
      name: "Gyudon Rice",
      description:
        "Caramelized grilled sirloin slices with onion and mushrooms, over kombu rice with peanuts, sesame, pickled radish, crispy bacon and spices.",
      alt: "Gyudon Rice at MÂJI by Cerón, where to eat in Salento",
    },
    curry: {
      tag: "Rice",
      name: "Curry Coconut Shrimp Rice",
      description:
        "Rice scented with coconut oil and curry, nuts and shrimp, served with fermented pickles.",
      alt: "Curry Coconut Shrimp Rice at MÂJI by Cerón, Asian cuisine in Salento",
    },
    shoku: {
      tag: "Grill",
      name: "Shoku Beef",
      description:
        "400 g New York strip grilled over soy broth with butter, honey and local chili. With house kimchi, lemon green beans, mushrooms and white rice.",
      alt: "Shoku Beef at MÂJI by Cerón, restaurant in Salento, Quindío",
    },
    mushrooms: {
      tag: "Vegetarian",
      name: "Mushrooms Udon",
      description:
        "Dry udon with cream and smoky notes, three kinds of mushrooms confit in tamarind and honey, and breaded zucchini coins.",
      alt: "Vegetarian Mushrooms Udon at MÂJI by Cerón, ramen and Asian cuisine in Salento",
    },
  },
  beforeVisit: {
    title: "Before you come",
    items: {
      vegetarian: "Vegetarian options and children's menu",
      pet: "Pet friendly, with a dog menu",
      languages: "Service in Spanish and English",
      intimate: "Intimate space: write to us ahead to secure your table",
      pickup: "You can order for pickup. We do not deliver",
      allergies: "Tell us about your allergies or restrictions before ordering",
    },
  },
  schedule: {
    title: "Hours",
    weekdays: "Monday to Thursday",
    weekdaysHours: "1:00 p.m. – 4:00 p.m. and 6:00 p.m. – 9:00 p.m.",
    weekend: "Friday and Saturday",
    weekendHours: "1:00 p.m. – 4:00 p.m. and 6:00 p.m. – 10:00 p.m.",
    sunday: "Sunday",
    sundayHours: "closed",
    note: "We close every day between 4:00 p.m. and 6:00 p.m. Special Sunday and holiday openings are announced on our social media. If you have any questions, write to us.",
  },
  location: {
    title: "How to get there",
    address: "Carrera 5 #7-34, Mall La Herrería, Salento, Quindío, Colombia",
    subtitle:
      "A few minutes from the Valle de Cocora, an ideal stop if you are looking for where to eat in Salento.",
    notice:
      "The last stretch is pedestrian. Google Maps usually marks the spot one block earlier: keep walking along Carrera 5 and look for our illuminated sign at Mall La Herrería.",
    mapTitle: "Location map of MÂJI by Cerón in Salento, Quindío",
    ctaMaps: "Open in Google Maps",
    ctaWhatsapp: "Ask for directions on WhatsApp",
  },
  closing: {
    title: "We wait for you in Salento",
    text: "Write to us and we will help you plan your visit.",
    cta: "Write to us on WhatsApp",
  },
  footer: {
    schedule: "Monday to Saturday · 1:00 p.m. – 4:00 p.m. and 6:00 p.m. – 9:00 / 10:00 p.m.",
    sunday: "Sunday: closed",
    legal:
      "Ask our team about ingredients and allergens. Excessive alcohol consumption is harmful to health. The sale of alcoholic beverages to minors is prohibited.",
    copyright: "© MÂJI by Cerón · Salento, Quindío, Colombia.",
  },
  float: {
    label: "Write to us",
    aria: "Write to MÂJI by Cerón on WhatsApp",
  },
};